import { useState, FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import { PublicHeader } from "../components/Header";
import { Button } from "../components/Button";
import { Input } from "../components/Input";
import { ErrorBanner } from "../components/ErrorBanner";
import { resetByCode } from "../api/auth";
import { setParentJwt } from "../api/client";

export function ResetByCodePage() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");

    if (password !== passwordConfirm) {
      setError("Пароли не совпадают");
      return;
    }
    if (password.length < 8) {
      setError("Пароль должен быть не короче 8 символов");
      return;
    }
    if (!/\d/.test(password)) {
      setError("Пароль должен содержать хотя бы одну цифру");
      return;
    }

    setLoading(true);
    try {
      const res = await resetByCode(code.toUpperCase(), email, password);
      setParentJwt(res.token);
      navigate("/cabinet");
    } catch (err: unknown) {
      const ex = err as { response?: { data?: { detail?: string | unknown } } };
      const msg = ex?.response?.data?.detail;
      setError(
        typeof msg === "string"
          ? msg
          : "Неверный код, email или код уже использован/истёк."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center p-6">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md bg-white p-8 border border-[var(--color-line)]"
        >
          <h1
            className="text-3xl mb-2"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Сброс по коду от учителя
          </h1>
          <p className="text-[var(--color-muted)] mb-6 text-sm">
            Если у вас нет доступа к email — попросите классного руководителя
            или завуча выдать одноразовый код для сброса пароля. Код действует
            24 часа.
          </p>

          <ErrorBanner message={error} />

          <Input
            label="Email вашего аккаунта"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="email"
          />

          <Input
            label="Код от учителя"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="ABCD1234"
            maxLength={8}
            pattern="[A-HJ-NP-Z2-9]{8}"
            hint="8 символов без 0, O, 1, I"
            required
          />

          <Input
            label="Новый пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            hint="Мин. 8 символов, обязательно цифра"
            autoComplete="new-password"
          />
          <Input
            label="Повторите пароль"
            type="password"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            required
            autoComplete="new-password"
          />

          <Button
            type="submit"
            variant="primary"
            loading={loading}
            className="w-full"
          >
            Установить пароль
          </Button>

          <div className="mt-4 text-center text-sm space-x-4">
            <Link to="/forgot" className="text-[var(--color-accent)]">
              Сброс по email
            </Link>
            <Link to="/login" className="text-[var(--color-accent)]">
              Войти
            </Link>
          </div>
        </form>
      </main>
    </div>
  );
}
